import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { INegotiationCreateRequest, IRFQSupplierResponseAnalysis } from '../models';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class BuyerSupplierService {

  constructor(private http: HttpClient, private _encryptionService: EncryptionService) { }

  public analyseSupplierResponse(pdId: any) : Observable<IAPIResponse<IRFQSupplierResponseAnalysis[]>> {
    return this.http.get<IAPIResponse<IRFQSupplierResponseAnalysis[]>>(`${API_URL.BUYER.SUPPLIER_COMMUNICATION.ANALYZE_RESPONSE}?prId=${pdId}`);
  }

  public createNegotiation(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.NEGOTIATIONS.CREATE}`, body);
  }
  
  public updateNegotiation(body: any) : Observable<any> {
    // return this.http.put<any>(`${API_URL.BUYER.NEGOTIATIONS.UPDATE}`, body);
    return this.http.post<any>(`${API_URL.BUYER.NEGOTIATIONS.UPDATE}`, body);
  }

  public createAutoPO(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.AUTO_PO}`, body);
  }

  public updatePoNotification(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.UPDATE_PO_NOTIFICATION}`, body);
  }


  public getTaxCodes() : Observable<any> {
    return this.http.get<any>(`${API_URL.BUYER.GET_TAX_CODE}`);
  }
  
  public updateQuotationStatus(quotationData: any[]) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.UPDATE_QUOTATION_STATUS}`, quotationData);
  }
  public prAssignedToAnotherManager(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.PR_ASSIGNED_TO_ANOTHER_MANAGER}`, body);
  }
  
}
